var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkBroken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1494_70037)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.99992 2.66683L5.99992 1.3335M9.99992 13.3335L9.99992 14.6668M2.66658 6.00016L1.33325 6.00016M13.3333 10.0002L14.6666 10.0002M3.27606 3.27631L2.33325 2.3335M12.7238 12.724L13.6666 13.6668M7.99992 11.7714L6.5857 13.1856C5.54431 14.227 3.85587 14.227 2.81447 13.1856C1.77307 12.1442 1.77307 10.4558 2.81447 9.41438L4.22868 8.00016M11.7712 8.00016L13.1854 6.58595C14.2268 5.54455 14.2268 3.85611 13.1854 2.81471C12.144 1.77332 10.4555 1.77332 9.41413 2.81471L7.99992 4.22893",
    stroke: "black",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1494_70037"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkBroken);
export default __webpack_public_path__ + "static/media/link-broken.6830358e7da0991914e02a4c39732d61.svg";
export { ForwardRef as ReactComponent };